import '../../styles/Effects/Effects.scss';

/** Fixed, decorative aurora + grid + grain behind every page. */
export default function Background() {
  return (
    <div className="bg-fx" aria-hidden="true">
      <div className="bg-fx__aurora bg-fx__aurora--1" />
      <div className="bg-fx__aurora bg-fx__aurora--2" />
      <div className="bg-fx__aurora bg-fx__aurora--3" />
      <div className="bg-fx__grid" />
      <div className="bg-fx__grain" />
    </div>
  );
}
